export type Question = { id: number; text: string; englishText: string; group: "l_f" | "e_r" | "a_n" | "g_c" };

export const questions: Question[] = [
  {
    id: 1,
    group: "l_f",
    text: "在關係中，由我來主導行程和計畫，會讓我感覺更安心。",
    englishText: "I feel more at ease when I take the lead in planning our schedule and activities in a relationship.",
  },
  {
    id: 2,
    group: "l_f",
    text: "在社交場合中，我常常自然地成為我們這對情侶的「發言人」或「代表」。",
    englishText: 'In social settings, I often naturally become the "spokesperson" or "representative" for our couple.',
  },
  // {
  //   id: 3,
  //   group: "l_f",
  //   text: "「我來規劃，能讓我們的關係走得更順」比較符合我的想法。",
  //   englishText: 'The idea that "Our relationship runs smoother when I do the planning" aligns more with my thinking.',
  // },
  // {
  //   id: 4,
  //   group: "l_f",
  //   text: "我認為為了效率，關係中最好有一個人負責拿定主意。",
  //   englishText:
  //     "I believe for the sake of efficiency, it's best if one person is primarily responsible for making decisions in a relationship.",
  // },
  {
    id: 5,
    group: "l_f",
    text: "我通常是那個主動提出週末活動計畫的人。",
    englishText: "I am usually the one who proactively suggests plans for weekend activities.",
  },
  // {
  //   id: 6,
  //   group: "l_f",
  //   text: "當考慮領養寵物時，我認為應該由我主導研究品種、責任分配和長期照護計劃。",
  //   englishText:
  //     "When considering adopting a pet, I believe I should lead the research on breeds, responsibility allocation, and long-term care plans.",
  // },
  {
    id: 7,
    group: "l_f",
    text: "當伴侶在職業發展上遇到瓶頸時，我的本能反應是主動幫他/她分析利弊，並提議規劃可行的下一步。",
    englishText:
      "When my partner encounters a bottleneck in their career development, my instinct is to proactively help them analyze the pros and cons and suggest planning viable next steps.",
  },
  {
    id: 8,
    group: "l_f",
    text: "即使伴侶比我更擅長理財，在進行重大的共同投資或儲蓄決策時，我仍然希望擁有主導權或否決權。",
    englishText:
      "Even if my partner is better at managing finances than I am, I still want to have the lead or veto power when making significant joint investment or savings decisions.",
  },
  // {
  //   id: 9,
  //   group: "l_f",
  //   text: "當討論未來幾年內的家庭財務目標（如買車、買房）時，我認為我的意見應佔主導。",
  //   englishText:
  //     "When discussing family financial goals for the next few years (like buying a car or house), I believe my opinion should be dominant.",
  // },
  {
    id: 10,
    group: "l_f",
    text: "當伴侶問「今晚吃什麼？」時，我通常會直接提出幾個具體的選項，而不是只表示「我都可以」或「你決定就好」。",
    englishText:
      'When my partner asks, "What should we eat tonight?" I usually directly suggest a few concrete options rather than just saying "I\'m fine with anything" or "You decide."',
  },

  // {
  //   id: 11,
  //   group: "e_r",
  //   text: "當我意識到和伴侶之間存在一個難以解決的分歧時，我會反覆地找對方討論，直到我們找到某種共識為止，而非逃避問題。",
  //   englishText:
  //     "When I realize there is a disagreement between my partner and me that is difficult to resolve, I will repeatedly seek to discuss it until we reach some consensus, rather than avoiding the issue.",
  // },
  {
    id: 12,
    group: "e_r",
    text: "經過疲憊的一天，與親近的人交談讓我感到充電和恢復，而非消耗。",
    englishText:
      "After a tiring day, talking with close ones makes me feel recharged and restored, rather than drained.",
  },
  {
    id: 13,
    group: "e_r",
    text: "我認為，情侶爭吵時「先把問題講清楚」比「各自冷靜一晚」更重要。",
    englishText:
      "I believe that talking through the problem is more important than cooling off separately for a night when a couple argues.",
  },
  {
    id: 14,
    group: "e_r",
    text: "我認為用語言直接表達愛與關心，比僅用行動來得更重要。",
    englishText:
      "I believe directly expressing love and care through words is more important than showing it through actions alone.",
  },
  // {
  //   id: 15,
  //   group: "e_r",
  //   text: "我的喜怒哀樂很容易從臉上看出來。",
  //   englishText: "My happiness, anger, sadness, and joy are easily visible on my face.",
  // },
  {
    id: 16,
    group: "e_r",
    text: "當伴侶心情不好時，我會主動關心並引導他傾訴。",
    englishText:
      "When my partner is in a bad mood, I take the initiative to care for them and guide them to talk about it.",
  },
  // {
  //   id: 17,
  //   group: "e_r",
  //   text: "我認為「我愛你」這句話應該經常說，才能維繫感情。",
  //   englishText: 'I believe the phrase "I love you" should be said often to maintain an intimate relationship.',
  // },
  {
    id: 18,
    group: "e_r",
    text: "我喜歡在社交媒體上分享我和伴侶的日常生活。",
    englishText: "I enjoy sharing details of my daily life with my partner on social media.",
  },
  {
    id: 19,
    group: "e_r",
    text: "我經常在閒暇時主動發送訊息與伴侶分享所見所聞。",
    englishText: "I often proactively send messages to my partner during my free time to share things I see and hear.",
  },
  // {
  //   id: 20,
  //   group: "e_r",
  //   text: "我認為相愛的兩個人之間不應該有任何秘密。",
  //   englishText: "I believe there shouldn't be any secrets between two people in love.",
  // },

  {
    id: 21,
    group: "a_n",
    text: "我認為對於人生順其自然就好，不需要有太詳細的計劃。",
    englishText: "I believe one should go with the flow in life and doesn't need overly detailed plans.",
  },
  {
    id: 22,
    group: "a_n",
    text: "如果有一筆意外之財，我會更想用它來體驗人生，而不是存起來。",
    englishText: "If I came into an unexpected fortune, I would rather use it to experience life than to save it up.",
  },
  {
    id: 23,
    group: "a_n",
    text: "我認為穩定的工作可能會束縛個人的自由與發展。",
    englishText: "I believe a stable job might restrict personal freedom and development.",
  },
  {
    id: 24,
    group: "a_n",
    text: "選擇伴侶時，來電的感覺和化學反應比經濟條件更重要。",
    englishText: "When choosing a partner, chemistry and spark are more important than financial status.",
  },
  {
    id: 25,
    group: "a_n",
    text: "我認為結婚證書只是一張紙，真摯的感情不需要它來證明。",
    englishText: "I believe a marriage certificate is just a piece of paper; sincere love doesn't need it as proof.",
  },
  // {
  //   id: 26,
  //   group: "a_n",
  //   text: "我喜歡隨心所欲、沒有預先安排的週末。",
  //   englishText: "I prefer weekends that are spontaneous and unplanned.",
  // },
  // {
  //   id: 27,
  //   group: "a_n",
  //   text: "我認為金錢最重要的功能是為夢想提供燃料，而不是為安穩生活提供保障。",
  //   englishText:
  //     "I believe the most important function of money is to fuel dreams, not to provide security for a stable life.",
  // },
  {
    id: 28,
    group: "a_n",
    text: "我認為一個充實而完整的人生，並不一定需要通過組建家庭來實現。",
    englishText: "I believe a fulfilling and complete life does not necessarily require starting a family.",
  },
  // {
  //   id: 29,
  //   group: "a_n",
  //   text: "面對一個環遊世界的機會（即使需要辭去穩定工作），我的第一反應通常是興奮多於擔憂。",
  //   englishText:
  //     "Faced with an opportunity to travel the world (even if it means quitting a stable job), my first reaction is usually excitement more than worry.",
  // },
  // {
  //   id: 30,
  //   group: "a_n",
  //   text: "我認為人生的意義在於不斷體驗新事物。",
  //   englishText: "I believe the meaning of life lies in constantly experiencing new things.",
  // },

  {
    id: 31,
    group: "g_c",
    text: "在愛情中，「個人的成長」比「彼此的舒適」更為重要。",
    englishText: 'In a relationship, "personal growth" is more important than "mutual comfort."',
  },
  {
    id: 32,
    group: "g_c",
    text: "對於伴侶提議的挑戰性活動（如陶藝、舞蹈工作坊），我通常會樂於嘗試，而非拒絕新事物。",
    englishText:
      "When my partner suggests a challenging activity (like a pottery or dance workshop), I am usually happy to try it rather than rejecting new experiences.",
  },
  // {
  //   id: 33,
  //   group: "g_c",
  //   text: "當伴侶發現我有他認為不好的長期習慣或特點時，我會希望他直接向我指出，而非無條件地包容接納。",
  //   englishText:
  //     "If my partner notices a long-term habit or trait of mine they think is not good, I would want them to point it out directly rather than unconditionally accepting it.",
  // },
  {
    id: 34,
    group: "g_c",
    text: "我認為衝突會令我更了解我的伴侶而非破壞我們的關係。",
    englishText: "I believe conflicts help me understand my partner better rather than damaging our relationship.",
  },
  {
    id: 35,
    group: "g_c",
    text: "我希望我的伴侶能像教練一樣，鞭策我前進。",
    englishText: "I hope my partner can act as a life coach to push me forward.",
  },
  // {
  //   id: 36,
  //   group: "g_c",
  //   text: "當伴侶滿足於現狀時，我認為鼓勵他尋求突破，比完全接納他當下的狀態更能體現我的愛。",
  //   englishText:
  //     "When my partner is content with the status quo, I believe encouraging them to seek breakthroughs demonstrates my love more than fully accepting their current state.",
  // },
  {
    id: 37,
    group: "g_c",
    text: "我認為，即使明知某些話題（如政治、金錢觀）可能引發爭執，主動與伴侶討論它們對長遠的關係也是有益的。",
    englishText:
      "I believe proactively discussing controversial topics with my partner (like politics or finances) is beneficial for our long-term relationship, even though this might cause arguments.",
  },
  // {
  //   id: 38,
  //   group: "g_c",
  //   text: "在假日，我更傾向「一起學習一項新技能」而非「一起放鬆休息」度過方式。",
  //   englishText:
  //     'On holidays, I prefer spending time "learning a new skill together" over "relaxing and resting together."',
  // },
  // {
  //   id: 39,
  //   group: "g_c",
  //   text: "我認為，伴侶有責任時常提醒對方未達到的目標和潛力，即使這會讓對方感到些許壓力。",
  //   englishText:
  //     "I believe partners have a responsibility to frequently remind each other of their goals and potential, even if this brings certain pressure.",
  // },
  {
    id: 40,
    group: "g_c",
    text: "在親密關係中，我認為「共同經歷的挑戰」比「日常累積的舒適」更能鑄就堅實的感情基礎。",
    englishText:
      "In a relationship, I believe the challenges faced together forge a more solid emotional foundation than the daily comforts that are accumulated.",
  },
];
